import { EmpathyXConfig } from '../../models';
import { DeepPartial } from '../../utils';
import { DEFAULT_EMPATHIZE_CONFIG as empathize } from './components/empathize.config';
import { DEFAULT_FACETS_CONFIG as facets } from './components/facets.config';
import { DEFAULT_RELATED_TAGS_CONFIG as relatedTags } from './components/related-tags.config';
import { DEFAULT_RESULTS_GRID_CONFIG as resultsGrid } from './components/results-grid.config';
import { DEFAULT_SCROLL_CONFIG as scroll } from './components/scroll.config';
import { DEFAULT_SEARCH_BOX_CONFIG as searchBox } from './components/search-box.config';
import { DEFAULT_SORT_CONFIG as sort } from './components/sort.config';
import { DEFAULT_CORE_CONFIG as core } from './core.config';

export const DEFAULT_DESKTOP_EMPATHY_X_CONFIG: DeepPartial<EmpathyXConfig> = {
  core,
  empathize,
  facets,
  relatedTags,
  resultsGrid,
  searchBox,
  scroll,
  sort
};
